import {
  useTranslation,
  Col,
  Row,
  useShowToastNotification,
  ENotificationType,
  TRtkErrorType,
} from '@packages/utils';
import { useTheme } from 'styled-components';
import { EIconNames, Icon } from 'components/Base/Icon';
import { useDeleteELCPlaceMutation } from 'redux/apiSlice/elcs.slice';
import { TRemoveELCPlaceProps } from './RemoveELCPlace.types';

const RemoveELCPlace = ({ placeId, elcId }: TRemoveELCPlaceProps) => {
  const theme = useTheme();
  const { showToastNotification } = useShowToastNotification();
  const { t } = useTranslation({
    keyPrefix:
      'descriptions.admin-portal.elcs.detail.elc-places-tab.list.actions.delete',
  });
  const [deleteELCPlace, { isLoading }] = useDeleteELCPlaceMutation();

  const handleSubmit = async (e: { preventDefault: () => void }) => {
    if (isLoading) {
      e.preventDefault();
      return;
    }
    try {
      await deleteELCPlace({
        elcId,
        placeId,
      }).unwrap();
      showToastNotification({
        message: t('SUCCESS_MESSAGE'),
        type: ENotificationType.SUCCESS,
      });
    } catch (err) {
      showToastNotification({
        message: (err as TRtkErrorType)?.data?.message,
        type: ENotificationType.ERROR,
      });
    }
  };

  return (
    <Row justify="center">
      <Col onClick={handleSubmit}>
        <Icon
          icon={EIconNames.DELETE_OUTLINED}
          color={theme.colorBlackIconColor}
          className="pointer"
          tooltip={{ title: t('DELETE_TOOLTIP') }}
        />
      </Col>
    </Row>
  );
};

export default RemoveELCPlace;
